<template>
  <v-layout row justify-center>
    <v-dialog v-model="showResetPurchase">
      <v-layout class="dialog-container" row justify-center>
        <v-card max-width="500">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0 primary--text"></h3>
              <h3 class="headline mb-0">Reiniciar Compra?</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span class="grey--text"
              >Ao voltar a ingressos, você vai perder os ingressos reservados
              até o momento e deverá escolher os lugares novamente.</span
            >
          </v-card-text>

          <v-card-text>
            <span class="grey--text">Deseja continuar mesmo assim?</span>
          </v-card-text>

          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="normal-text"
              flat
              outline
              round
              @click="closeDialog"
              >Não, Manter a Compra</v-btn
            >
            <v-btn
              color="primary"
              class="normal-text"
              depressed
              round
              @click="reset"
              ><span class="px-4 white--text">Sim</span></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    showResetPurchase() {
      return this.$store.getters.showResetPurchase;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$store.dispatch('setResetPurchase', false);
    },
    async reset() {
      const evento = this.$store.getters.eventID;
      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};

      await Promise.all(
        this.cartProducts.map(async product => {
          await Promise.all(
            product.map(async el => {
              if (el.seats) {
                await Promise.all(
                  el.seats.map(async sc => {
                    return this.$store.dispatch('unbookPurchaseSeats', sc);
                  })
                );
              }
            })
          );
        })
      );

      await this.$store.dispatch('deleteCheckoutState', evento);
      if (
        checkoutState &&
        checkoutState[evento] &&
        checkoutState[evento].userToken
      )
        await this.$store.dispatch('getClientData');
      await this.$store.dispatch('loadCheckoutState', evento);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);
    },
  },
};
</script>
